<template>
	<div class="spinner_wrap">
		<div class="overlay"></div>
		<div class="spinner">
			<img src="@/assets/images/icon/language.png" alt="" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'Spinner',
};
</script>

<style scoped></style>
